import React, { useState } from "react";
import axios from "axios";
import { guestbookSites, environment } from "../../../settings/IntegrationConstants";
import { Header, HeaderContainer, L300, InputItem, T300Large, InputSection, Input, InputErrorText, PrimaryButton } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import WarningTriangle from "@/components/UI/Icons/WarningTriangle";
import I18n from "../../../translations/i18n";

type PasswordProps = {
  onLoginClick: () => void;
  onResetPasswordConfirmation: () => void;
}

const ForgotPasswordScreen = ({ onLoginClick, onResetPasswordConfirmation }: PasswordProps) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false)

  const onSubmitResetPassword = (e: React.FormEvent) => {
    e.preventDefault();
    setError(false)
    const submissionData = {
      email: email,
      wid: window.gb_data.widget.identifier,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/reset_password`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          onResetPasswordConfirmation()
        }
      })
      .catch((error) => {
          setError(true)
    });
  }

  return (
    <form onSubmit={onSubmitResetPassword} style={{ width: "100%" }}>
      <HeaderContainer>
        <Header>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.forgot_password.header`)}</Header>
      </HeaderContainer>
      <InputSection>
        <InputItem>
          <L300>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.email_address`)}</L300>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            required
            hasError={error}
          />
          {error && 
            <InputErrorText>
              <WarningTriangle/>
              {I18n.t(`views.hotel_integration.components.widget.mobile_modal.forgot_password.warning`)}
            </InputErrorText>
          }
        </InputItem>
      </InputSection>
      <PrimaryButton type="submit">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.reset_password`)}</PrimaryButton>
      <T300Large>
        <span onClick={onLoginClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.different_account`)}</span>
      </T300Large>
      <TermsPrivacy/>
    </form>
  );
}

export default ForgotPasswordScreen